import { RequestServerClass } from '@/util/request';
import publishObjectPath from '@/util/configRegistry';
const upLoadPath: any = publishObjectPath.value.upLoadPath;

export class MapServer {
  public rSerivce: any;
  public rSerivce1: any;

  constructor(opt: any, axiosFilterFn?: any) {
    opt.headers = {
      'Content-Type': 'application/json',
      'token': (localStorage as any).getItem('token'),
    };
    this.rSerivce = new RequestServerClass(opt);
    opt.baseURL = upLoadPath;
    this.rSerivce1 = new RequestServerClass(opt);
  }
  // 公司搜索
  public searchEnterprise(params: any): any {
    const url = '/api/gemp/haz/enterprise/list/v1';
    return this.rSerivce.serverObj.post(url , params);
  }
  // 企业统计
  public statisticsEnterprise(params: any): any {
    const url = '/api/gemp/haz/enterprise/gis/statistics/v1';
    return this.rSerivce.serverObj.post(url , params);
  }
  // 点击查看企业详情
  public FnClickSearchRes(params: any): any {
    const url = '/api/gemp/haz/enterprise/detail/v1';
    return this.rSerivce.serverObj.post(url , params);
  }

  // 获取图例信息
  public FnGetLegend(params: any): any {
    const url = '/api/gemp/haz/enterprise/gis/info/v1';
    return this.rSerivce.serverObj.post(url , params);
  }
  // 获取门类信息
  public getCategory(params: any): any {
    const url = '/api/gemp/haz/enterprise/dict/list/industryclass/v1';
    return this.rSerivce.serverObj.post(url , params);
  }
  // 获取贸易类型
  public getType(): any {
    const url = '/api/gemp/haz/enterprise/dict/list/tradecode/v1';
    return this.rSerivce.serverObj.post(url , {});
  }
  // 获取自贸区信息
  public getArea(): any {
    const url = '/api/gemp/haz/enterprise/dict/list/freetradezone/v1';
    return this.rSerivce.serverObj.post(url);
  }
  // 获取企业分类
  public getAnterpriseClassify(): any {
    const url = '/api/gemp/haz/enterprise/dict/list/enterpriseclassify/v1';
    return this.rSerivce.serverObj.post(url);
  }
  // 获取信息发布列表
  public getInfoPushList(params: any): any {
    const url = '/api/gemp/market/list/v1';
    return this.rSerivce.serverObj.post(url, params);
  }
  // 获取广告信息通过企业id
  public getAdByEnterpriseId(params: any): any {
    const url = '/api/gemp/market/adsense/list/v1';
    return this.rSerivce.serverObj.post(url, params);
  }
  // 获取信息发布详情
  public getInfoPushDetail(params: any): any {
    const url = '/api/gemp/market/viewInfo/v1';
    return this.rSerivce.serverObj.post(url, params);
  }
  // 获取广告列表
  public getAdList(params: any): any {
    const url = '/api/gemp/market/adsense/listAttach/v1';
    return this.rSerivce.serverObj.post(url, params);
  }
  // 空间查询企业
  public getEnterpriseListByGeometry(params: any): any {
    const url = '/api/gemp/haz/enterprise/list/gis/v1';
    return this.rSerivce.serverObj.post(url, params);
  }
  // 获取园区列表
  public getParkinfoList(params: any): any {
    const url = '/api/gemp/haz/enterprise/parkinfo/list/v1';
    return this.rSerivce.serverObj.post(url, params);
  }
  // 获取园区详情
  public getParkinfo(params: any): any {
    const url = '/api/gemp/haz/enterprise/parkinfo/phase/view/v1';
    return this.rSerivce.serverObj.post(url, params);
  }
  // 获取园区详情
  public getAdById(params: any): any {
    const url = '/api/gemp/market/adsense/view/v1';
    return this.rSerivce.serverObj.post(url, params);
  }
  public getChildrenCategory(params: any): any {
    const url = '/api/gemp/haz/enterprise/dict/list/industrycode/v1';
    return this.rSerivce.serverObj.post(url , params);
  }
  public getScheme(params: any): any {
    const url = `/gemp-user/api/gemp/user/screen/list/v1?type=` + params.type;
    return this.rSerivce1.serverObj.post(url , params);
  }
  public saveScheme(params: any): any {
    const url = `/gemp-user/api/gemp/user/screen/add/v1`;
    return this.rSerivce1.serverObj.post(url , params);
  }
  public getAnalysis(params: any): any {
    const url = '/api/gemp/haz/enterprise/statistics/v1';
    return this.rSerivce.serverObj.post(url , params);
  }
  public getCapital(): any {
    const url = '/api/gemp/haz/enterprise/statregisteredCapital/v1';
    return this.rSerivce.serverObj.post(url , {});
  }
  public getMoneyType(): any {
    const url = '/api/gemp/haz/enterprise/statistics/tradecode/v1';
    return this.rSerivce.serverObj.post(url , {});
  }
}
